/*
*
* File JS per il TPL Careers
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './careers.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{

});

//--------------------------------------------------------------------//